import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import IndustriesSection from './components/IndustriesSection';
import AboutSection from './components/AboutSection';
import QualitySection from './components/QualitySection';
import Footer from './components/Footer';
import { LanguageProvider } from './context/LanguageContext';

export default function HomePage() {
  return (
    <LanguageProvider>
      <div className="min-h-screen font-sans">
        <Navbar />
        <HeroSection />
        <ServicesSection />
        <IndustriesSection />
        <AboutSection />
        <QualitySection />
        <Footer />
      </div>
    </LanguageProvider>
  );
}
